(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR",
                {
                    url: "/ROR",
                    component: "rorwizard",
                    PageTitle: "ROR Wizard",
                    //requiredPermissions: "NewAccountWizard:View",
                    resolve: {     
                       
                    }
                });
        }
    ]);

    app.component("rorwizard",
        {
            templateUrl: "App/RORWizard/rorwizard.html",
            controller: rorwizardCtrl,
            bindings: {              
            }
        });

    rorwizardCtrl.$inject = ["$http", "onboardingApi"];

    function rorwizardCtrl($http, onboardingApi) {
        var $ctrl = this;

        
    }
})(window.app, window.angular); // jshint ignore:line